import React from 'react';
import { useParams } from 'react-router-dom';
import { Col, Flex, Row, Skeleton } from 'antd';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetWarehouseTask } from 'api/warehouse-task/use-get-warehouse-task';
import { ECommentEntityName } from 'types/comment';
import { ClientInfoCard } from 'components/clients/client-info-card';
import { CommentsCard } from 'components/comments/comments-card';
import { WhTaskMain } from 'components/wh-tasks/wh-task-main';
import { WhTaskMainInfo } from 'components/wh-tasks/wh-task-main-info';
import { WhTaskPageHeader } from 'components/wh-tasks/wh-task-page-header';
import { WhTaskStatistics } from 'components/wh-tasks/wh-task-statistics';

export const WhTaskPage: React.FC = () => {
  const { whTaskId } = useParams();

  const { data: whTask } = useGetWarehouseTask(Number(whTaskId));

  return (
    <DefaultPageLayout header={whTask ? <WhTaskPageHeader whTask={whTask} /> : undefined}>
      {whTask ? (
        <Row gutter={16}>
          <Col span={17}>
            <Flex gap='middle' vertical>
              <WhTaskStatistics whTask={whTask} />
              <WhTaskMain whTaskId={whTask.id} />
            </Flex>
          </Col>
          <Col span={7}>
            <Flex gap='middle' vertical>
              <WhTaskMainInfo whTask={whTask} />
              <ClientInfoCard client={whTask.client} contactId={whTask.contactId} />
              <CommentsCard entityName={ECommentEntityName.warehouseTask} entityId={whTask.id} />
            </Flex>
          </Col>
        </Row>
      ) : (
        <Skeleton />
      )}
    </DefaultPageLayout>
  );
};
